import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';

import Icon from 'shopper/components/Icon';

import useDialog from 'hooks/useDialog';

import { sendEvent } from 'lib/gtag';
import placeholder from 'lib/placeholder';

import Button from '../../Shopper/Button';

const WishlistDialog = dynamic(
  () => import('components/Wishlist/WishlistDialog'),
  { ssr: false }
);

const WishlistButton = ({ gaEventCategory }) => {
  const { showDialog } = useDialog();

  const onOpenWishlist = () => {
    sendEvent({ action: 'show_wishlist', category: gaEventCategory });
    showDialog(WishlistDialog);
  };

  return (
    <Button
      aria-label="Abrir lista de desejos"
      icon={<Icon name="heart" />}
      onClick={onOpenWishlist}
    >
      {placeholder('actions.openWishlist')}
    </Button>
  );
};

WishlistButton.propTypes = {
  gaEventCategory: PropTypes.string.isRequired,
};

export default WishlistButton;
